<template>
  <div class="flex flex-wrap h-full">
    <img
      v-if="clientDetails.basic_details.cover_picture!=''"
      :src="clientDetails.basic_details.cover_picture"
      alt=""
    />
    <img v-else src="@/assets/images/user_bg.png" alt="" />
    <div class="edit_holder cursor-pointer">
      <span class="material-icons-outlined">edit</span>
      <input type="file" accept="image/png" @change="uploadImg($event, 1)" />
    </div>
    <vs-popup
      fullscreen
      title="Edit Image"
      :active.sync="editImagePopup"
      classContent="popup-example"
    >
      <div id="app" style="height: 100%; width: 100%">
        <cropper
          :src="imageDataUrl"
          aspect-ratio="0"
          :result-image="imageDataUrl"
          result-image-size="{w: 340,h: 200}"
          init-max-area="true"
          area-type="rectangle"
          class="cropper"
          @change="onChange"
        ></cropper>
      </div>
      <vs-row vs-justify="flex-end" class="mt-2">
        <vs-button color="primary" type="filled" @click="saveImage" class="mr-3"
          >Save</vs-button
        >
        <vs-button color="danger" type="filled" @click="cancelImageUpload"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { UploadImage } from '@/api/common'
import { repository } from '@/mixins/repository'
export default {
  mixins: [repository],
  props: {
    clientDetails: {
      required: true,
      default: () => {}
    },
    platform_module_id: { type: Number, default: 0 }
  },
  data () {
    return {
      multipleSelect: false,
      profileImage:
        'https://freedesignfile.com/upload/2017/03/Green-square-modern-background-vector.jpg',
      profileHover: false,
      editImagePopup: false,
      imageDataUrl: null,
      cropImage: null
    }
  },
  created () {
    this.getRepositoryId(this.platform_module_id)
  },
  methods: {
    uploadImg (e, num) {
      const file = e.target.files[0]
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      const fileSize = e.target.files[0].size / 1024 / 1024
      if (fileSize < 5) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = window.URL.createObjectURL(new Blob([e.target.result]))
            // fd.append('upload_path', 'FeedWall')
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
            this.editImagePopup = true
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        //
      } else {
        this.option.img = ''

        this.dialogVisible = false
        this.$vs.notify({
          title: 'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
    },
    onChange ({ canvas }) {
      canvas.toBlob((blob) => {
        const fd = new FormData()
        fd.append('files[]', blob, 'image.jpg')
        fd.append('upload_path', 'ads')
        this.cropImage = fd
      })
    },
    cancelImageUpload () {
      this.imageDataUrl = null
      this.editImagePopup = false
    },
    async getUploadFiles (file_id_payload) {
      this.$vs.notify({
        title: 'Success',
        text: 'File Uploaded Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 1000
      })

      this.$emit('changingImage', file_id_payload[0].file_path, 'CoverImage')
    },
    async saveImage () {
      try {
        // const customer_id = this.$store.state.LoginStorage.user_details.customer_id
        const payload = this.$store.state.LoginStorage.user_details.customer_id
        const { data } = await UploadImage(this.cropImage, payload)

        const imageUrl = `${data.data.cdn}${data.data.files[0].file_path}`
        this.$emit('changingImage', imageUrl, 'CoverImage')
        this.imageDataUrl = null
        this.editImagePopup = false
        //
        this.$vs.notify({
          title: 'Success',
          text: 'file uploaded Successfully',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        this.$vs.notify({
          title: 'error',
          text: e,
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'error'
        })
      }
    }
  }
}
</script>
